import { configFactory, getOrThrow } from '@digitsole/blackburn-configuration';

export const versionConfig = configFactory({
  default: getOrThrow('sha', { type: 'string', prefix: 'blackburn' }) as string
});
